import { useTranslations } from "next-intl";
import Image from "@components/core/Image";
import Button from "@components/core/Button";

function ShortReviewsFinished({ close }) {
  const t = useTranslations("common");

  return (
    <div className="d-flex flex-grow-1 justify-content-center align-items-center">
      <div className="d-flex flex-column align-items-center px-3 pb-7 text-center">
        <div style={{ width: "80px" }}>
          <Image
            src="partyNature"
            className="w-100"
            alt={t("drawer.review_short.btn.alt")}
          />
        </div>
        <div className="py-4 my-2">
          <h3 className="mb-2 text-center">{t("review_short.thank_you")}</h3>
          <p className="mb-0 text-gray text-center">{t("review_short.you_helped")}</p>
        </div>

        <Button
          variant="primary"
          onClick={close}
          fullWidth
        >
          {t("review_short.done")}
        </Button>
      </div>
    </div>
  );
}

export default ShortReviewsFinished;
